import cloneDeep from 'lodash.clonedeep';
import type { MarketCode, Token } from '../@types/Token';
import type { TrackEvent } from '../@types/Tracking';
import { postJSONUnauthorized } from '../fetch';

const TIMEOUT = 1500;

let __tracking_payloads: TrackEvent[] = [];
let timeoutId = 0;

const getTracking = () => window.__TRACKING__;

const waykeAnalyticsTracker = (
  trackedEvents: TrackEvent[],
  marketCode?: MarketCode | MarketCode[],
) => {
  if (!marketCode) {
    return;
  }

  const m = Array.isArray(marketCode) ? marketCode[0] : marketCode;
  const uri = getTracking()?.find((t) => t.marketCode === m)?.uri;

  if (!uri) {
    return;
  }

  const cleanedPayloads = trackedEvents;
  postJSONUnauthorized(uri, cleanedPayloads);
};

const __trackers = [waykeAnalyticsTracker];

const trackerHub = (payload: TrackEvent, token: Token | undefined) => {
  clearTimeout(timeoutId);

  timeoutId = setTimeout(() => {
    __trackers.forEach((tracker) => {
      const independentPayload = __tracking_payloads.map((p) => cloneDeep(p));
      tracker(independentPayload, token?.['market-code']);
    });
    __tracking_payloads = [];
  }, TIMEOUT) as unknown as number;

  __tracking_payloads.push(payload);
};

export default trackerHub;
